import { ApiResourceMethod } from '@/api/api-requests-factory';
import { BaseResponse } from '@/api/api-requests-factory/models/response.model';
import {
  GetGlobalPaymentMethodListRequestPayload,
  GlobalPaymentMethodList,
} from '@/models/ps-management/ps-management.model';

export default class GetGlobalPaymentMethodListRequest extends ApiResourceMethod<GlobalPaymentMethodList> {
  public perform(params: GetGlobalPaymentMethodListRequestPayload): Promise<GlobalPaymentMethodList> {
    return this.performer.requestWithMapper(
      { params },
      (payload: BaseResponse<GlobalPaymentMethodList>) => {
        return payload.data;
      },
    );
  }
}
